/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectDomain } from './ProjectDomain';
import {
    ProjectDomainFromJSON,
    ProjectDomainFromJSONTyped,
    ProjectDomainToJSON,
    ProjectDomainToJSONTyped,
} from './ProjectDomain';
import type { ProjectCentre } from './ProjectCentre';
import {
    ProjectCentreFromJSON,
    ProjectCentreFromJSONTyped,
    ProjectCentreToJSON,
    ProjectCentreToJSONTyped,
} from './ProjectCentre';
import type { OtherSystemSource } from './OtherSystemSource';
import {
    OtherSystemSourceFromJSON,
    OtherSystemSourceFromJSONTyped,
    OtherSystemSourceToJSON,
    OtherSystemSourceToJSONTyped,
} from './OtherSystemSource';

/**
 * 
 * @export
 * @interface OtherSystemSourceWithCentreAndDomain
 */
export interface OtherSystemSourceWithCentreAndDomain {
    /**
     * 
     * @type {OtherSystemSource}
     * @memberof OtherSystemSourceWithCentreAndDomain
     */
    otherSystemSource?: OtherSystemSource;
    /**
     * 
     * @type {ProjectCentre}
     * @memberof OtherSystemSourceWithCentreAndDomain
     */
    projectCentre?: ProjectCentre | null;
    /**
     * 
     * @type {ProjectDomain}
     * @memberof OtherSystemSourceWithCentreAndDomain
     */
    projectDomain?: ProjectDomain | null;
}

/**
 * Check if a given object implements the OtherSystemSourceWithCentreAndDomain interface.
 */
export function instanceOfOtherSystemSourceWithCentreAndDomain(value: object): value is OtherSystemSourceWithCentreAndDomain {
    return true;
}

export function OtherSystemSourceWithCentreAndDomainFromJSON(json: any): OtherSystemSourceWithCentreAndDomain {
    return OtherSystemSourceWithCentreAndDomainFromJSONTyped(json, false);
}

export function OtherSystemSourceWithCentreAndDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherSystemSourceWithCentreAndDomain {
    if (json == null) {
        return json;
    }
    return {
        
        'otherSystemSource': json['otherSystemSource'] == null ? undefined : OtherSystemSourceFromJSON(json['otherSystemSource']),
        'projectCentre': json['projectCentre'] === undefined ? undefined : json['projectCentre'] === null ? null : ProjectCentreFromJSON(json['projectCentre']),
        'projectDomain': json['projectDomain'] === undefined ? undefined : json['projectDomain'] === null ? null : ProjectDomainFromJSON(json['projectDomain']),
    };
}

export function OtherSystemSourceWithCentreAndDomainToJSON(json: any): OtherSystemSourceWithCentreAndDomain {
    return OtherSystemSourceWithCentreAndDomainToJSONTyped(json, false);
}

export function OtherSystemSourceWithCentreAndDomainToJSONTyped(value?: OtherSystemSourceWithCentreAndDomain | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'otherSystemSource': OtherSystemSourceToJSON(value['otherSystemSource']),
        'projectCentre': ProjectCentreToJSON(value['projectCentre']),
        'projectDomain': ProjectDomainToJSON(value['projectDomain']),
    };
}

